import { lighten, MenuItem, Stack, useTheme } from "@mui/material"
import { ArticleActionButton, ErpIconType } from "@tm/models"
import { useMemo } from "react"
import { Icon } from "../../../muiStyled/DataDisplay/Icons"
import { Typography } from "../../../muiStyled/DataDisplay/typographie"

type Props = {
    action: ArticleActionButton
    isSelected?: boolean
    handleCloseMore: () => void
}

export function ActionMenuItem(props: Props) {
    const { action, isSelected, handleCloseMore } = props
    const { iconType, text, icon, handler, isHighlight } = action
    const theme = useTheme()

    const color = useMemo(() => {
        return isHighlight ? theme.palette.primary.main : undefined
    }, [theme.palette, isHighlight])

    return (
        <MenuItem
            key={ErpIconType[iconType]}
            onClick={mergeHandler(handleCloseMore, handler)}
            sx={isSelected ? { backgroundColor: lighten(theme.palette.primary.main, 0.6) } : {}}
        >
            <Stack direction="row" gap={1} alignItems="center">
                <Icon name={icon} color={color} />
                <Typography variant="body2" color={color}>
                    {text}
                </Typography>
            </Stack>
        </MenuItem>
    )
}

function mergeHandler(...handler: ((event?: React.MouseEvent<HTMLElement>) => void)[]) {
    return (event?: React.MouseEvent<HTMLElement>) => handler.forEach((handle) => handle(event))
}
